import { theme } from '@noths/polaris-client-ribbons-base';
import { pxToRem } from '@noths/polaris-client-styles';
import { palette } from '@noths/polaris-design-system-theme-brand2026customer';
import { css } from 'styled-components';

const { spacing } = theme;

const iconSize = 24;

export const searchFieldContainer = css`
  position: relative;
`;

export const focusSearchIconSubmit = css`
  background-color: ${palette.purpleBase};
  color: ${palette.neutralWhite};
  --iconColor: ${palette.neutralWhite};
  border-bottom-right-radius: ${pxToRem(10)};
  border-top-right-radius: ${pxToRem(10)};
`;

const iconButton = css`
  color: ${palette.neutralBrandBlack};
  --iconColor: ${palette.neutralBrandBlack};
`;

export const submit = css`
  ${iconButton}
  margin: 0;
  padding: 0 ${pxToRem(12)};

  &:not(:disabled) {
    &:hover,
    &:focus {
      ${focusSearchIconSubmit}
    }
  }
`;

export const clear = css`
  ${iconButton}
  margin: ${pxToRem(2)} 0;
  padding-right: ${spacing.sm}px;
  background-color: ${palette.neutralWhite};
`;

export const icon = css`
  width: ${pxToRem(iconSize)};
  height: ${pxToRem(iconSize)};
`;

export const buttonContainer = css`
  display: flex;
  height: 100%;
  position: absolute;
  top: 0;
  right: 0;
`;
